module.exports = __webpack_public_path__ + "web_static/img/mobilesmart.d7578f98.gif";